import axios from 'axios';

$(() => {
    const $viewer = $('.job-recommender-job-viewer');
    const $preClicked = $('#job-recommender-job-viewer__pre-clicked');

    /**
     * Clear any existing job detail cards.
     */
    function removeJobDetail() {
        $viewer.find('.job-detail').remove();
    }

    /**
     * Hide the pre-clicked state, and no-recs state, and show the defined markup.
     * @param {number} jobId - The Id of the job being viewed
     * @param {string} jobViewUrl - The url used to register a new job view
     * @param {string} markup
     */
    function updateJobDetail(jobId, jobViewUrl, markup) {
        removeJobDetail();

        if ($preClicked.length) {
            $preClicked.hide();
        }

        $viewer.prepend(markup);
        $viewer.data('job-id', jobId);

        createJobView(jobViewUrl);
    }

    /**
     * If the viewer is inside a wrapper component, keep the height of the viewer
     * maxed out within the wrapper.
     */
    function updateViewerSize() {
        const $wrapper = $viewer.closest('.job-recommender-jobs-wrapper');

        if ($wrapper.length === 0) {
            return;
        }

        /**
         * Subtracting 6 from the height to account for the drop shadow.
         */
        const height = $wrapper.height() - 6;

        if ($viewer.height() !== height) {
            $viewer.height(height);
        }
    }

    function createJobView(jobViewUrl) {
        axios.post(jobViewUrl);
    }

    $(document).on('job-recommender:list:active', (evt) => {
        const { jobId, jobViewUrl } = evt.detail;
        const currentViewerJob = $viewer?.data('jobId') ? parseInt($viewer.data('jobId')) : null;

        if (!$viewer.length || currentViewerJob === jobId) {
            /**
             * The job is already displayed, so we don't need to do anything.
             */
            return;
        }

        if (!Object.hasOwn(window, 'jobDetailViewerCache')) {
            window.jobDetailViewerCache = {};
        }

        const url = new URL($viewer.data('source'));
        url.searchParams.append('job', jobId);

        updateViewerSize();

        if (jobId in window.jobDetailViewerCache) {
            updateJobDetail(jobId, jobViewUrl, window.jobDetailViewerCache[jobId]);
            return;
        }

        axios.get(url.href)
            .then((res) => {
                window.jobDetailViewerCache[jobId] = res.data.markup;
                updateJobDetail(jobId, jobViewUrl, res.data.markup);
            })
            // eslint-disable-next-line no-console
            .catch((err) => console.error(err));
    });

    $(document).on('job-recommender:list:recommendations-available', () => {
        removeJobDetail();
        $viewer.find('.card').hide();

        if ($preClicked.length) {
            $preClicked.show();
        }
    });

    $(window).on('resize', updateViewerSize);
});
